import React from "react";
import type { FC, ReactNodeArray } from "react";
import { useStyles } from "./styles";

export const RecentlyCardsHeader: FC<{children: ReactNodeArray}> = ({ children }) => {
  const classes = useStyles();

  const [leftChildren, rightChildren] = children;

  return (
    <div className={classes.header}>
      <div className={classes.leftSide}>{leftChildren}</div>
      <div className={classes.rightSide}>{rightChildren}</div>
    </div>
  );
};
